/* eslint-disable no-unused-vars */
import { Tooltip } from "recharts";
import upcircle from "../../../assets/images/upcircle.svg";
import twOverwrites from "../../../utils/tailwind-overwrites.json";
import { Api } from "../../../api";
import { useEffect, useState } from "react";
import { RadialBarChart, RadialBar } from "recharts";
//this is added
import { TIME_SPAN_OPTIONS } from "../../../utils/constants";
import moment from "moment/moment";
import Loader from "../../../component/common/Loader";
import { Bar } from "react-chartjs-2";
import { PeapDashboardData } from "../../../utils/pageContent";

const options2 = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
      labels: {
        font: {
          family: "P22Mackinac",
        },
      },
    },
    tooltip: {
      bodyFont: {
        family: "P22Mackinac",
      },
      titleFont: {
        family: "P22Mackinac",
      },
    },
  },
  scales: {
    x: {
      grid: {
        drawOnChartArea: false,
      },
      ticks: {
        font: {
          family: "P22Mackinac",
        },
      },
    },
    y: {
      grid: {
        drawOnChartArea: false,
      },
      ticks: {
        stepSize: 1,
        precision: 0,
        font: {
          family: "P22Mackinac",
        },
      },
    },
  },
};

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="rounded-xl border bg-white p-4 shadow-lg dark:border-shoorah-buttonColor dark:bg-shoorah-darkBgColor dark:text-shoorah-offWhite">
        {payload?.[0]?.payload?.name}: {payload?.[0]?.payload?.value}
      </div>
    );
  }

  return null;
};

const Insights = () => {
  const [DashboardData, setDashboardData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* TIMESPAN STATES */
  const [wellpointsSpan, setWellPointsSpan] = useState("Today");
  const [sessionSpan, setSessionSpan] = useState("Today");
  const [ageSpan, setAgeSpan] = useState("Today");
  const [genderSpan, setGenderSpan] = useState("Today");
  const [saleIncreaseSpan, setSaleIncreaseSpan] = useState("Today");
  const [newCustomerSpan, setNewCustomerSpan] = useState("Today");
  const [realTimeSpan, setRealTimeSpan] = useState("Today");

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await Api.getPeapDashboard();
      if (response?.data?.meta?.code === 200) {
        setDashboardData(response.data.data);
      }
    } catch (error) {
      console.error("🚀 ~ Fetching Data ~ error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="h-full mt-6 max-w-[100%]">
      {loading ? <Loader /> : null}

      <div className="grid grid-cols-3 gap-8">
        {/* COLUMN 1 */}
        <div className="col-span-3 xxl:col-span-2 gap-4 sm:gap-8 flex flex-col">
          <div className="grid grid-cols-1 sm_tab:grid-cols-5 gap-4 sm:gap-8">
            {/* PROFILE */}
            <div className="col-span-3 flex-col sm:flex-row flex items-center sm_tab:block sm_tab:col-span-2 gap-0 h-auto lg:rounded-2xl rounded-xl bg-white border-[1.5px] border-shoorah-borderGray dark:border-none dark:bg-shoorah-darkBgTabColor text-center relative">
              <div className="absolute top-[14px] left-[-8px] w-2 h-12 bg-shoorah-primary rounded-tl-[10px] rounded-bl-[10px]"></div>
              <div className="absolute top-5 left-0">
                <div className="pl-4 pr-8 py-2 bg-gradient-to-r from-shoorah-primary to-shoorah-secondary text-white text-sm font-medium ribbon-clip-path">
                  {PeapDashboardData.photoRibbonText}
                </div>
              </div>
              <div className="sm_tab:h-1/2 w-full sm:w-1/2 sm_tab:w-full overflow-hidden">
                <img
                  loading="lazy"
                  src={
                    DashboardData?.topDoctor?.profile ||
                    "https://cdn.pixabay.com/photo/2024/03/25/18/35/ai-generated-8655320_640.png"
                  }
                  alt={DashboardData?.topDoctor?.name || "No expert found"}
                  className="flex h-full rounded-tl-xl lg:rounded-tl-2xl sm:rounded-bl-lg sm_tab:rounded-bl-[0] rounded-tr-2xl sm:rounded-tr-[0] sm_tab:rounded-tr-xl lg:rounded-tr-2xl"
                />
              </div>
              <div className="flex sm_tab:h-1/2 w-full sm:w-1/2 sm_tab:w-full flex-col gap-6 sm_tab:gap-8">
                <div className="flex flex-col gap-0">
                  <h2 className="flex items-end justify-center text-center text-xl font-medium mt-8 leading-none capitalize">
                    {DashboardData?.topDoctor?.name || "No expert found"}
                  </h2>
                  <p className="text-base leading-none pt-3 font-medium text-gray-800 dark:text-white">
                    {DashboardData?.topDoctor?.job_title || "No expert found"}
                  </p>
                </div>
                <p className="mt-0 flex flex-col items-center gap-5 text-gray-500">
                  Sessions Booked this month
                  <button className="rounded-[5rem] bg-shoorah-secondary pb-2 pl-9 pr-9 pt-2 text-xl text-white">
                    {DashboardData?.topDoctor?.totalSessions || 0}
                  </button>
                </p>
              </div>
            </div>

            {/* PROFILE WIDGETS */}
            <div className="col-span-3 gap-4 sm:gap-8 flex flex-col">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-8">
                {/* TOTAL MEMBERS SUPPORTED */}
                <div className="col-span-1">
                  <div className="lg:rounded-2xl rounded-xl h-full p-4 sm:p-7 bg-white border-[1.5px] border-shoorah-borderGray dark:border-none dark:bg-shoorah-darkBgTabColor">
                    <p className="sm:h-1/3 w-full mb-4 sm:mb-0 text-left text-lg sm:text-xl font-medium leading-6 text-shoorah-darkBgTabColor dark:text-shoorah-offWhite xl:h-1/2 xl:w-1/6">
                      {PeapDashboardData.totalMemberSupportedText}
                    </p>
                    <h2 className="dark:text-shoorah-secondary-500 w-full text-wrap break-all pt-0 text-3xl sm:text-5xl 2xl:text-6xl font-medium text-shoorah-secondary dark:text-shoorah-lightBlue1 xl:w-full">
                      {DashboardData?.totalMembersSupported ?? 0}
                    </h2>
                  </div>
                </div>

                {/* SESSIONS AND WORK RELATED CASES */}
                <div className="col-span-1 flex flex-col gap-4 sm:gap-8">
                  {/* TOTAL SESSIONS */}
                  <div className="overflow-hidden lg:rounded-2xl rounded-xl bg-white border-[1.5px] border-shoorah-borderGray dark:border-none text-center dark:bg-shoorah-darkBgTabColor">
                    <div className="flex h-2/3 items-center justify-center p-7">
                      <h2 className="text-4xl font-medium leading-tight text-shoorah-darkBgTabColor dark:text-shoorah-offWhite">
                        {DashboardData?.totalSessions || 0}
                      </h2>
                    </div>
                    <div className="flex h-1/3 w-full items-center justify-center bg-shoorah-secondary px-4 py-2 text-center">
                      <p className="text-base m-auto leading-none text-white">
                        Total Session
                      </p>
                    </div>
                  </div>

                  {/* WORK RELATED CASES */}
                  <div className="overflow-hidden lg:rounded-2xl rounded-xl bg-white border-[1.5px] border-shoorah-borderGray dark:border-none text-center dark:bg-shoorah-darkBgTabColor">
                    <div className="flex h-2/3 items-center justify-center p-7">
                      <h2 className="text-4xl font-medium leading-tight text-shoorah-darkBgTabColor dark:text-shoorah-offWhite">
                        {DashboardData?.workRelatedCases ?? 0}
                      </h2>
                    </div>
                    <div className="flex h-1/3 w-full items-center justify-center bg-shoorah-secondary px-4 py-2 text-center">
                      <p className="text-base leading-none text-white">
                        Work Related Cases
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* WELLPOINTS USED */}
              <div className="col-span-1 lg:rounded-2xl rounded-xl bg-white border-[1.5px] border-shoorah-borderGray dark:border-none dark:bg-shoorah-darkBgTabColor">
                <div className="flex flex-col gap-4 sm:gap-8 lg:rounded-2xl rounded-xl p-4 sm:p-7">
                  <h3 className="h-1/2 text-left text-lg sm:text-xl font-medium leading-6 flex justify-between text-shoorah-darkBgTabColor dark:text-shoorah-offWhite">
                    {PeapDashboardData.wellPointsUsedText}
                    <select
                      className="block h-8 w-20 rounded-md border border-gray-300 bg-gray-50 px-1 text-sm text-gray-900 dark:border-shoorah-buttonColor dark:bg-shoorah-darkBgColor dark:text-shoorah-lightBlue1 dark:placeholder-shoorah-charcoal"
                      id="most_popular_sessions"
                      name="most_popular_sessions"
                      onChange={(e) => {
                        setWellPointsSpan(e.target.value);
                      }}
                    >
                      {TIME_SPAN_OPTIONS.map(({ name }) => (
                        <option key={name} value={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                  </h3>
                  <p className="text-wrap pt-1 leading-tight text-gray-400">
                    {wellpointsSpan === "Today" &&
                      `Well points used on ${moment(new Date()).format(
                        "DD.MM.YYYY"
                      )}`}

                    {wellpointsSpan === "Week" &&
                      `Well points used from ${moment(new Date())
                        .subtract(7, "days")
                        .format("DD.MM.YYYY")} to ${moment(new Date()).format(
                        "DD.MM.YYYY"
                      )}`}

                    {wellpointsSpan === "Month" &&
                      `Well points used from ${moment(new Date())
                        .subtract(1, "months")
                        .format("DD.MM.YYYY")} to ${moment(new Date()).format(
                        "DD.MM.YYYY"
                      )}`}

                    {wellpointsSpan === "Year" &&
                      `Well points used from ${moment(new Date())
                        .subtract(1, "year")
                        .format("DD.MM.YYYY")} to ${moment(new Date()).format(
                        "DD.MM.YYYY"
                      )}`}
                  </p>
                  <div className="flex flex-row justify-between gap-5">
                    <div className="mb-5 flex items-center flex-wrap sm:flex-nowrap gap-4 sm:gap-10 align-middle">
                      {loading ? (
                        <h2 className="text-[2.75rem] font-medium text-[#4a56db]">
                          0
                        </h2>
                      ) : (
                        <h2 className="text-[2.75rem] font-medium text-[#4a56db]">
                          {wellpointsSpan === "Month" &&
                            (parseFloat(
                              DashboardData?.userStats?.wellpoints?.month * 10
                            ).toFixed(0) ??
                              0)}
                          {wellpointsSpan === "Week" &&
                            (parseFloat(
                              DashboardData?.userStats?.wellpoints?.week * 10
                            ).toFixed(0) ??
                              0)}
                          {wellpointsSpan === "Today" &&
                            (parseFloat(
                              DashboardData?.userStats?.wellpoints?.today * 10
                            ).toFixed(0) ??
                              0)}
                          {wellpointsSpan === "Year" &&
                            (parseFloat(
                              DashboardData?.userStats?.wellpoints?.year * 10
                            ).toFixed(0) ??
                              0)}
                        </h2>
                      )}
                      <div className="flex items-center gap-2">
                        <img
                          className="w-[2rem]"
                          loading="lazy"
                          src={upcircle}
                          alt="upcircle icon"
                        />

                        <div className="flex items-center w-full sm:w-auto justify-center overflow-hidden">
                          <p className="text-sm flex items-center pt-1 leading-none text-gray-900 dark:text-white">
                            {wellpointsSpan === "Month" &&
                              (parseFloat(
                                DashboardData?.userStats
                                  ?.wellpointsPercentageChange?.month
                              ).toFixed(0) ??
                                0)}
                            {wellpointsSpan === "Week" &&
                              (parseFloat(
                                DashboardData?.userStats
                                  ?.wellpointsPercentageChange?.week
                              ).toFixed(0) ??
                                0)}
                            {wellpointsSpan === "Today" &&
                              (parseFloat(
                                DashboardData?.userStats
                                  ?.wellpointsPercentageChange?.today
                              ).toFixed(0) ??
                                0)}
                            {wellpointsSpan === "Year" &&
                              (parseFloat(
                                DashboardData?.userStats
                                  ?.wellpointsPercentageChange?.year
                              ).toFixed(0) ??
                                0)}
                            % Increase compared to last month
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* SESSIONS BOOKED BY JOB GRADE */}
          <div className="grid w-full grid-cols-1 lg:rounded-2xl rounded-xl bg-white border-[1.5px] border-shoorah-borderGray dark:border-none dark:bg-shoorah-darkBgTabColor p-4 sm:p-8">
            <h2 className="text-lg sm:text-xl font-medium sm:mb-6">
              Session Booked By Job Grade
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-20">
              {DashboardData?.jobRoleStats?.map((item, index) => (
                <div
                  key={index}
                  className="flex h-16 w-full flex-col items-center"
                >
                  <div className="flex w-full justify-between">
                    <span className="w-30 font-medium text-gray-400 capitalize">
                      {item.jobRole}
                    </span>
                    <span className="font-medium text-gray-800">
                      {item.count}
                    </span>
                  </div>
                  <div className="mt-5 flex h-2 w-full overflow-hidden rounded-full bg-gray-200">
                    <div
                      className={`h-2 w-full`}
                      style={{
                        width: `${
                          (item.count / DashboardData?.totalSessions) * 100
                        }%`,
                        backgroundColor: item.color,
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* SALES AND NEW CUSTOMER WIDGET */}
          <div className="grid  grid-cols-1 sm_tab:grid-cols-2 gap-8">
            {/* SALE INCREASE */}
            <div className="col-span-1 lg:rounded-2xl rounded-xl bg-white border-[1.5px] border-shoorah-borderGray dark:border-none dark:bg-shoorah-darkBgTabColor p-4 sm:p-6">
              <div className="flex items-center justify-between">
                <p className="text-wrap leading-tight text-gray-400">Session</p>
                <select
                  className="block h-8 w-20 rounded-md border border-gray-300 bg-gray-50 px-1 text-sm text-gray-900 dark:border-shoorah-buttonColor dark:bg-shoorah-darkBgColor dark:text-shoorah-lightBlue1 dark:placeholder-shoorah-charcoal"
                  id="most_popular_sessions"
                  name="most_popular_sessions"
                  onChange={(e) => {
                    setSaleIncreaseSpan(e.target.value);
                  }}
                >
                  {TIME_SPAN_OPTIONS.map(({ name }) => (
                    <option key={name} value={name}>
                      {name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mt-2">
                <h3 className="text-xl font-medium">Sale Increase</h3>
                <div className="mt-1 flex items-end justify-between">
                  <p className="mt-1 text-3xl font-medium">
                    £{" "}
                    {saleIncreaseSpan === "Month" &&
                      (parseFloat(
                        DashboardData?.userStats?.wellpoints?.month
                      ).toFixed(0) ??
                        0)}
                    {saleIncreaseSpan === "Week" &&
                      (parseFloat(
                        DashboardData?.userStats?.wellpoints?.week
                      ).toFixed(0) ??
                        0)}
                    {saleIncreaseSpan === "Today" &&
                      (parseFloat(
                        DashboardData?.userStats?.wellpoints?.today
                      ).toFixed(0) ??
                        0)}
                    {saleIncreaseSpan === "Year" &&
                      (parseFloat(
                        DashboardData?.userStats?.wellpoints?.year
                      ).toFixed(0) ??
                        0)}
                  </p>

                  {saleIncreaseSpan === "Today" && (
                    <p
                      className={`mt-1 ${
                        DashboardData?.userStats?.wellpointsPercentageChange
                          ?.today > 0
                          ? "text-green-500"
                          : "text-red-500"
                      }`}
                    >
                      {parseFloat(
                        DashboardData?.userStats?.wellpointsPercentageChange
                          ?.today
                      ).toFixed(2) ?? 0}
                      %
                    </p>
                  )}

                  {saleIncreaseSpan === "Week" && (
                    <p
                      className={`mt-1 ${
                        DashboardData?.userStats?.wellpointsPercentageChange
                          ?.week > 0
                          ? "text-green-500"
                          : "text-red-500"
                      }`}
                    >
                      {parseFloat(
                        DashboardData?.userStats?.wellpointsPercentageChange
                          ?.week
                      ).toFixed(2) ?? 0}
                      %
                    </p>
                  )}

                  {saleIncreaseSpan === "Month" && (
                    <p
                      className={`mt-1 ${
                        DashboardData?.userStats?.wellpointsPercentageChange
                          ?.month > 0
                          ? "text-green-500"
                          : "text-red-500"
                      }`}
                    >
                      {parseFloat(
                        DashboardData?.userStats?.wellpointsPercentageChange
                          ?.month
                      ).toFixed(2) ?? 0}
                      %
                    </p>
                  )}

                  {saleIncreaseSpan === "Year" && (
                    <p
                      className={`mt-1 ${
                        DashboardData?.userStats?.wellpointsPercentageChange
                          ?.year > 0
                          ? "text-green-500"
                          : "text-red-500"
                      }`}
                    >
                      {parseFloat(
                        DashboardData?.userStats?.wellpointsPercentageChange
                          ?.year
                      ).toFixed(2) ?? 0}
                      %
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* NEW CUSTOMER */}
            <div className="col-span-1 lg:rounded-2xl rounded-xl bg-white border-[1.5px] border-shoorah-borderGray dark:border-none dark:bg-shoorah-darkBgTabColor p-4 sm:p-6">
              <div className="flex items-center justify-between">
                <p className="text-wrap leading-tight text-gray-400">Session</p>
                <select
                  className="block h-8 w-20 rounded-md border border-gray-300 bg-gray-50 px-1 text-sm text-gray-900 dark:border-shoorah-buttonColor dark:bg-shoorah-darkBgColor dark:text-shoorah-lightBlue1 dark:placeholder-shoorah-charcoal"
                  id="most_popular_sessions"
                  name="most_popular_sessions"
                  onChange={(e) => {
                    setNewCustomerSpan(e.target.value);
                  }}
                >
                  {TIME_SPAN_OPTIONS.map(({ name }) => (
                    <option key={name} value={name}>
                      {name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mt-2">
                <h3 className="text-xl font-medium">New Customer</h3>
                <div className="mt-1 flex items-end justify-between">
                  <p className="text-3xl font-medium">
                    {newCustomerSpan === "Month" &&
                      (parseFloat(
                        DashboardData?.userStats?.user?.month
                      ).toFixed(0) ??
                        0)}
                    {newCustomerSpan === "Week" &&
                      (parseFloat(DashboardData?.userStats?.user?.week).toFixed(
                        0
                      ) ??
                        0)}
                    {newCustomerSpan === "Today" &&
                      (parseFloat(
                        DashboardData?.userStats?.user?.today
                      ).toFixed(0) ??
                        0)}
                    {newCustomerSpan === "Year" &&
                      (parseFloat(DashboardData?.userStats?.user?.year).toFixed(
                        0
                      ) ??
                        0)}
                  </p>

                  {newCustomerSpan === "Today" && (
                    <p
                      className={`mt-1 ${
                        DashboardData?.userStats?.userPercentageChange?.today >
                        0
                          ? "text-green-500"
                          : "text-red-500"
                      }`}
                    >
                      {parseFloat(
                        DashboardData?.userStats?.userPercentageChange?.today
                      ).toFixed(2) ?? 0}
                      %
                    </p>
                  )}

                  {newCustomerSpan === "Week" && (
                    <p
                      className={`mt-1 ${
                        DashboardData?.userStats?.userPercentageChange?.week > 0
                          ? "text-green-500"
                          : "text-red-500"
                      }`}
                    >
                      {parseFloat(
                        DashboardData?.userStats?.userPercentageChange?.week
                      ).toFixed(2) ?? 0}
                      %
                    </p>
                  )}

                  {newCustomerSpan === "Month" && (
                    <p
                      className={`mt-1 ${
                        DashboardData?.userStats?.userPercentageChange?.month >
                        0
                          ? "text-green-500"
                          : "text-red-500"
                      }`}
                    >
                      {parseFloat(
                        DashboardData?.userStats?.userPercentageChange?.month
                      ).toFixed(2) ?? 0}
                      %
                    </p>
                  )}

                  {newCustomerSpan === "Year" && (
                    <p
                      className={`mt-1 ${
                        DashboardData?.userStats?.userPercentageChange?.year > 0
                          ? "text-green-500"
                          : "text-red-500"
                      }`}
                    >
                      {parseFloat(
                        DashboardData?.userStats?.userPercentageChange?.year
                      ).toFixed(2) ?? 0}
                      %
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* REAL TIME SESSIONS */}
          <div className="overflow-y-auto pb-2 sm:pb-0 horizontal-card-scrollbar">
            <div className="rounded-xl lg:rounded-2xl bg-white border-[1.5px] border-shoorah-borderGray dark:border-none dark:bg-shoorah-darkBgTabColor min-w-[527px]">
              <div className="flex items-center justify-between p-5">
                <div className="p-0">
                  <p className="flex justify-between text-gray-400">Session</p>
                  <p className="text-lg font-semibold text-black dark:text-white">
                    Real-Times Session
                  </p>
                </div>
                <div className="p-0">
                  <select
                    className="block h-8 w-20 rounded-md border border-gray-300 bg-gray-50 px-1 text-sm text-gray-900 dark:border-shoorah-buttonColor dark:bg-shoorah-darkBgColor dark:text-shoorah-lightBlue1 dark:placeholder-shoorah-charcoal"
                    id="most_popular_sessions"
                    name="most_popular_sessions"
                    onChange={(e) => {
                      setRealTimeSpan(e.target.value);
                    }}
                  >
                    {TIME_SPAN_OPTIONS.map(({ name }) => (
                      <option key={name} value={name}>
                        {name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="p-5 border-t border-shoorah-borderGray dark:border-none">
                <Bar
                  data={{
                    labels: [
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                      "Sunday",
                    ],
                    datasets: [
                      {
                        label: "Real time sessions",
                        data:
                          realTimeSpan === "Today"
                            ? DashboardData?.sessionCountByDays?.today?.map(
                                (data) => data.value
                              )
                            : realTimeSpan === "Week"
                            ? DashboardData?.sessionCountByDays?.week?.map(
                                (data) => data.value
                              )
                            : realTimeSpan === "Month"
                            ? DashboardData?.sessionCountByDays?.month?.map(
                                (data) => data.value
                              )
                            : DashboardData?.sessionCountByDays?.year?.map(
                                (data) => data.value
                              ),
                        backgroundColor: "#3a47ab",
                        borderColor: " #4a56db",
                        borderRadius: 3,
                        borderWidth: 1,
                      },
                    ],
                  }}
                  options={{
                    ...options2,
                  }}
                  className="!h-[222px]"
                />
              </div>
            </div>
          </div>
        </div>

        {/* COLUMN 2 */}
        <div className="col-span-3 xxl:col-span-1 flex-wrap flex-row flex xxl:flex-col gap-4 sm:gap-8">
          {/* MOST POPULAR SESSIONS */}
          <div className="card col-span-2 w-full sm_tab:w-[calc(50%-1rem)] xxl:w-full xxl:col-span-4 grid grid-cols-1 justify-center lg:rounded-2xl rounded-xl bg-white border-[1.5px] border-shoorah-borderGray dark:border-none p-4 sm:p-7 dark:bg-shoorah-darkBgTabColor sm:mt-0">
            <div className="flex w-full items-start justify-between text-left text-xl font-medium leading-6 text-shoorah-darkBgTabColor dark:text-shoorah-offWhite">
              <span>{PeapDashboardData.mostPopularSessionText}</span>
              <select
                className="block h-8 w-20 rounded-md border border-gray-300 bg-gray-50 px-1 text-sm text-gray-900 dark:border-shoorah-buttonColor dark:bg-shoorah-darkBgColor dark:text-shoorah-lightBlue1 dark:placeholder-shoorah-charcoal"
                id="most_popular_sessions"
                name="most_popular_sessions"
                onChange={(e) => {
                  setSessionSpan(e.target.value);
                }}
              >
                {TIME_SPAN_OPTIONS.map(({ name, value }) => (
                  <option key={name} value={name}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex justify-center">
              <RadialBarChart
                width={300}
                height={300}
                data={
                  sessionSpan === "Today"
                    ? DashboardData?.popularJobTitles?.today
                    : sessionSpan === "Week"
                    ? DashboardData?.popularJobTitles?.week
                    : sessionSpan === "Year"
                    ? DashboardData?.popularJobTitles?.year
                    : DashboardData?.popularJobTitles?.month
                }
                cx="50%"
                cy="50%"
                innerRadius="35%"
                outerRadius="110%"
                barSize={10}
                className="sm:!w-[300px] sm:!h-[300px] !h-[200px] !w-[200px]"
              >
                <RadialBar minAngle={15} dataKey="value" clockWise background />
                <Tooltip content={<CustomTooltip />} />
              </RadialBarChart>
            </div>
            <div className="flex w-full justify-center">
              <span className="mt-7 flex w-full flex-row flex-wrap justify-center gap-x-9 overflow-hidden lg:gap-y-6">
                {sessionSpan === "Today" &&
                  DashboardData?.popularJobTitles?.today?.map((data, index) => (
                    <span
                      key={index}
                      className="flex items-center gap-1 overflow-hidden"
                    >
                      <span
                        className={`h-4 w-4 rounded-md`}
                        style={{ backgroundColor: `${data?.fill}` }}
                      ></span>
                      <div className="ml-0 mr-0 flex flex-row gap-3 overflow-hidden">
                        <div className="truncate">
                          <div className="truncate text-gray-400">
                            {data?.name}
                          </div>
                        </div>
                      </div>
                    </span>
                  ))}
                {sessionSpan === "Week" &&
                  DashboardData?.popularJobTitles?.week?.map((data, index) => (
                    <span
                      key={index}
                      className="flex items-center gap-1 overflow-hidden"
                    >
                      <span
                        className={`h-4 w-4 rounded-md`}
                        style={{ backgroundColor: `${data?.fill}` }}
                      ></span>
                      <div className="ml-0 mr-0 flex flex-row gap-3 overflow-hidden">
                        <div className="truncate">
                          <div className="truncate text-gray-400">
                            {data?.name}
                          </div>
                        </div>
                      </div>
                    </span>
                  ))}
                {sessionSpan === "Month" &&
                  DashboardData?.popularJobTitles?.month?.map((data, index) => (
                    <span
                      key={index}
                      className="flex items-center gap-1 overflow-hidden"
                    >
                      <span
                        className={`h-4 w-4 rounded-md`}
                        style={{ backgroundColor: `${data?.fill}` }}
                      ></span>
                      <div className="ml-0 mr-0 flex flex-row gap-3 overflow-hidden">
                        <div className="truncate">
                          <div className="truncate text-gray-400">
                            {data?.name}
                          </div>
                        </div>
                      </div>
                    </span>
                  ))}
                {sessionSpan === "Year" &&
                  DashboardData?.popularJobTitles?.year?.map((data, index) => (
                    <span
                      key={index}
                      className="flex items-center gap-1 overflow-hidden"
                    >
                      <span
                        className={`h-4 w-4 rounded-md`}
                        style={{ backgroundColor: `${data?.fill}` }}
                      ></span>
                      <div className="ml-0 mr-0 flex flex-row gap-3 overflow-hidden">
                        <div className="truncate">
                          <div className="truncate text-gray-400">
                            {data?.name}
                          </div>
                        </div>
                      </div>
                    </span>
                  ))}
              </span>
            </div>
          </div>

          {/* AGE WISE DATA */}
          <div className="card col-span-2 w-full sm_tab:w-[calc(50%-1rem)] xxl:w-full xxl:col-span-4 grid grid-cols-1 justify-center lg:rounded-2xl rounded-xl bg-white border-[1.5px] border-shoorah-borderGray dark:border-none p-4 sm:p-7 dark:bg-shoorah-darkBgTabColor sm:mt-0">
            <div className="flex w-full items-start justify-between text-left text-xl font-medium leading-6 text-shoorah-darkBgTabColor dark:text-shoorah-offWhite">
              <span>{PeapDashboardData.ageText}</span>
              <select
                className="block h-8 w-20 rounded-md border border-gray-300 bg-gray-50 px-1 text-sm text-gray-900 dark:border-shoorah-buttonColor dark:bg-shoorah-darkBgColor dark:text-shoorah-lightBlue1 dark:placeholder-shoorah-charcoal"
                id="most_popular_sessions"
                name="most_popular_sessions"
                onChange={(e) => {
                  setAgeSpan(e.target.value);
                }}
              >
                {TIME_SPAN_OPTIONS.map(({ name }) => (
                  <option key={name} value={name}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
            <div className="sm:m-5 flex justify-center">
              <RadialBarChart
                width={300}
                height={300}
                data={
                  ageSpan === "Today"
                    ? DashboardData?.userStats?.age?.today
                    : ageSpan === "Week"
                    ? DashboardData?.userStats?.age?.week
                    : ageSpan === "Year"
                    ? DashboardData?.userStats?.age?.year
                    : DashboardData?.userStats?.age?.month
                }
                cx="50%"
                cy="50%"
                innerRadius="35%"
                outerRadius="110%"
                barSize={10}
                className="sm:!w-[300px] sm:!h-[300px] !h-[200px] !w-[200px]"
              >
                <RadialBar minAngle={15} dataKey="value" clockWise background />
                <Tooltip content={<CustomTooltip />} />
              </RadialBarChart>
            </div>
            <div className="flex w-full justify-center">
              <span className="mt-7 flex w-full flex-row flex-wrap justify-center gap-x-9 overflow-hidden lg:gap-y-6">
                {ageSpan === "Today" &&
                  DashboardData?.userStats?.age?.today?.map((data, index) => (
                    <span
                      key={index}
                      className="flex items-center gap-1 overflow-hidden"
                    >
                      <span
                        className={`h-4 w-4 rounded-md`}
                        style={{ backgroundColor: `${data?.fill}` }}
                      ></span>
                      <div className="ml-0 mr-0 flex flex-row gap-3 overflow-hidden">
                        <div className="truncate">
                          <div className="truncate text-gray-400">
                            {data?.name}
                          </div>
                        </div>
                      </div>
                    </span>
                  ))}
                {ageSpan === "Week" &&
                  DashboardData?.userStats?.age?.week?.map((data, index) => (
                    <span
                      key={index}
                      className="flex items-center gap-1 overflow-hidden"
                    >
                      <span
                        className={`h-4 w-4 rounded-md`}
                        style={{ backgroundColor: `${data?.fill}` }}
                      ></span>
                      <div className="ml-0 mr-0 flex flex-row gap-3 overflow-hidden">
                        <div className="truncate">
                          <div className="truncate text-gray-400">
                            {data?.name}
                          </div>
                        </div>
                      </div>
                    </span>
                  ))}
                {ageSpan === "Month" &&
                  DashboardData?.userStats?.age?.month?.map((data, index) => (
                    <span
                      key={index}
                      className="flex items-center gap-1 overflow-hidden"
                    >
                      <span
                        className={`h-4 w-4 rounded-md`}
                        style={{ backgroundColor: `${data?.fill}` }}
                      ></span>
                      <div className="ml-0 mr-0 flex flex-row gap-3 overflow-hidden">
                        <div className="truncate">
                          <div className="truncate text-gray-400">
                            {data?.name}
                          </div>
                        </div>
                      </div>
                    </span>
                  ))}
                {ageSpan === "Year" &&
                  DashboardData?.userStats?.age?.year?.map((data, index) => (
                    <span
                      key={index}
                      className="flex items-center gap-1 overflow-hidden"
                    >
                      <span
                        className={`h-4 w-4 rounded-md`}
                        style={{ backgroundColor: `${data?.fill}` }}
                      ></span>
                      <div className="ml-0 mr-0 flex flex-row gap-3 overflow-hidden">
                        <div className="truncate">
                          <div className="truncate text-gray-400">
                            {data?.name}
                          </div>
                        </div>
                      </div>
                    </span>
                  ))}
              </span>
            </div>
          </div>

          {/* GENDER WISE DATA */}
          <div className="card col-span-2 w-full sm_tab:w-[calc(50%-1rem)] xxl:w-full xxl:col-span-4 grid grid-cols-1 justify-center lg:rounded-2xl rounded-xl bg-white border-[1.5px] border-shoorah-borderGray dark:border-none p-4 sm:p-7 dark:bg-shoorah-darkBgTabColor sm:mt-0">
            <div className="flex w-full items-start justify-between text-left text-xl font-medium leading-6 text-shoorah-darkBgTabColor dark:text-shoorah-offWhite">
              <span>{PeapDashboardData.genderText}</span>
              <select
                className="block h-8 w-20 rounded-md border border-gray-300 bg-gray-50 px-1 text-sm text-gray-900 dark:border-shoorah-buttonColor dark:bg-shoorah-darkBgColor dark:text-shoorah-lightBlue1 dark:placeholder-shoorah-charcoal"
                id="most_popular_sessions"
                name="most_popular_sessions"
                onChange={(e) => {
                  setGenderSpan(e.target.value);
                }}
              >
                {TIME_SPAN_OPTIONS.map(({ name, value }) => (
                  <option key={name} value={name}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
            <div className="sm:m-5 flex justify-center">
              <RadialBarChart
                width={300}
                height={300}
                data={
                  genderSpan === "Today"
                    ? DashboardData?.userStats?.gender?.today
                    : genderSpan === "Week"
                    ? DashboardData?.userStats?.gender?.week
                    : genderSpan === "Year"
                    ? DashboardData?.userStats?.gender?.year
                    : DashboardData?.userStats?.gender?.month
                }
                cx="50%"
                cy="50%"
                innerRadius="35%"
                outerRadius="110%"
                barSize={10}
                className="sm:!w-[300px] sm:!h-[300px] !h-[200px] !w-[200px]"
              >
                <RadialBar minAngle={15} dataKey="value" clockWise background />
                <Tooltip content={<CustomTooltip />} />
              </RadialBarChart>
            </div>
            <div className="flex w-full justify-center">
              <span className="mt-7 flex w-full flex-row flex-wrap justify-center gap-x-9 overflow-hidden lg:gap-y-6">
                {genderSpan === "Today" &&
                  DashboardData?.userStats?.gender?.today?.map(
                    (data, index) => (
                      <span
                        key={index}
                        className="flex items-center gap-1 overflow-hidden"
                      >
                        <span
                          className={`h-4 w-4 rounded-md`}
                          style={{ backgroundColor: `${data?.fill}` }}
                        ></span>
                        <div className="ml-0 mr-0 flex flex-row gap-3 overflow-hidden">
                          <div className="truncate">
                            <div className="truncate text-gray-400">
                              {data?.name}
                            </div>
                          </div>
                        </div>
                      </span>
                    )
                  )}
                {genderSpan === "Week" &&
                  DashboardData?.userStats?.gender?.week?.map((data, index) => (
                    <span
                      key={index}
                      className="flex items-center gap-1 overflow-hidden"
                    >
                      <span
                        className={`h-4 w-4 rounded-md`}
                        style={{ backgroundColor: `${data?.fill}` }}
                      ></span>
                      <div className="ml-0 mr-0 flex flex-row gap-3 overflow-hidden">
                        <div className="truncate">
                          <div className="truncate text-gray-400">
                            {data?.name}
                          </div>
                        </div>
                      </div>
                    </span>
                  ))}
                {genderSpan === "Month" &&
                  DashboardData?.userStats?.gender?.month?.map(
                    (data, index) => (
                      <span
                        key={index}
                        className="flex items-center gap-1 overflow-hidden"
                      >
                        <span
                          className={`h-4 w-4 rounded-md`}
                          style={{ backgroundColor: `${data?.fill}` }}
                        ></span>
                        <div className="ml-0 mr-0 flex flex-row gap-3 overflow-hidden">
                          <div className="truncate">
                            <div className="truncate text-gray-400">
                              {data?.name}
                            </div>
                          </div>
                        </div>
                      </span>
                    )
                  )}
                {genderSpan === "Year" &&
                  DashboardData?.userStats?.gender?.year?.map((data, index) => (
                    <span
                      key={index}
                      className="flex items-center gap-1 overflow-hidden"
                    >
                      <span
                        className={`h-4 w-4 rounded-md`}
                        style={{ backgroundColor: `${data?.fill}` }}
                      ></span>
                      <div className="ml-0 mr-0 flex flex-row gap-3 overflow-hidden">
                        <div className="truncate">
                          <div className="truncate text-gray-400">
                            {data?.name}
                          </div>
                        </div>
                      </div>
                    </span>
                  ))}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Insights;
